import { ValidationRuleSchema } from 'vee-validate/dist/types/types'

const FLOAT_REGEX = /^[-]?([1-9]\d*|0)(\.\d)?$/

const Float: ValidationRuleSchema = {
  validate(value: string): boolean {
    return FLOAT_REGEX.test(value)
  },
}

export default Float
